import { getElementDimensions } from './get-element-dimensions';
/**
 * Returns the relative coordinates of the supplied element's centre point.
 */
export function getElementCentrePoint(element) {
    const elementDimensions = getElementDimensions(element, 'content-box');
    return {
        x: elementDimensions.width / 2,
        y: elementDimensions.height / 2
    };
}
//# sourceMappingURL=get-element-centre-point.js.map